import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5409429a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "status-overlay"
}
const _hoisted_2 = { class: "status-card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "status-msg" }, "正在回测中...", -1))
const _hoisted_4 = { class: "status-sub" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("刷新")
const _hoisted_6 = { class: "status-msg" }
const _hoisted_7 = { class: "status-countdown" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "status-msg" }, "策略/回测未找到", -1))
const _hoisted_9 = { class: "status-countdown" }
const _hoisted_10 = { class: "status-msg" }
const _hoisted_11 = { class: "status-countdown" }

import { ref, watch, onMounted, onUnmounted } from 'vue'
import { useStarRouter } from '@/utils/useStarTheme'


export default /*#__PURE__*/_defineComponent({
  __name: 'BacktestStatusOverlay',
  props: {
    status: null,
    toastString: null
  },
  emits: ["refresh"],
  setup(__props: any, { emit }: { emit: ({ (e: 'refresh'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { status: number; toastString?: string }




const { starPush } = useStarRouter()
const goHome = () => starPush('/star')

// ── 返回首页倒计时（status 3/4/5）────────────────────────────────────────────
const inner = ref(3)
let timer: ReturnType<typeof setInterval> | null = null

const startCountdown = () => {
    inner.value = 3
    if (timer) clearInterval(timer)
    timer = setInterval(() => {
        inner.value--
        if (inner.value <= 0) {
            clearInterval(timer!)
            goHome()
        }
    }, 1000)
}

// ── 自动刷新倒计时（status === 1，只触发一次）────────────────────────────────
const refreshCountdown = ref(3)
const autoRefreshed = ref(false)   // true = 已自动刷新过，显示手动文案
let refreshTimer: ReturnType<typeof setInterval> | null = null

const startRefreshCountdown = () => {
    refreshCountdown.value = 3
    autoRefreshed.value = false
    if (refreshTimer) clearInterval(refreshTimer)
    refreshTimer = setInterval(() => {
        refreshCountdown.value--
        if (refreshCountdown.value <= 0) {
            clearInterval(refreshTimer!)
            refreshTimer = null
            autoRefreshed.value = true   // 切换为手动文案
            emit('refresh')              // 自动刷新一次，之后不再自动
        }
    }, 1000)
}

const stopRefreshCountdown = () => {
    if (refreshTimer) { clearInterval(refreshTimer); refreshTimer = null }
}

// 手动点击：直接触发，不重启倒计时
const onManualRefresh = () => {
    emit('refresh')
}

// ── 监听 status ───────────────────────────────────────────────────────────────
watch(() => props.status, (val, oldVal) => {
    if (val === 1) {
        if (oldVal !== 1) startRefreshCountdown()
    } else {
        stopRefreshCountdown()
    }
    if (val === 3 || val === 4 || val === 5) startCountdown()
    else if (timer) { clearInterval(timer); timer = null }
})

onMounted(() => {
    if (props.status === 1) startRefreshCountdown()
})

onUnmounted(() => {
    if (timer) clearInterval(timer)
    stopRefreshCountdown()
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (__props.status !== 2)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (__props.status === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_3,
                _createElementVNode("p", _hoisted_4, _toDisplayString(autoRefreshed.value ? '请点击下面按钮进行刷新' : `${refreshCountdown.value}s 后自动刷新`), 1),
                _createVNode(_component_a_button, {
                  class: "status-btn",
                  onClick: onManualRefresh
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ], 64))
            : (__props.status === 3)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(__props.toastString || '回测失败'), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(inner.value) + " 秒后返回首页", 1)
                ], 64))
              : (__props.status === 4)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _hoisted_8,
                    _createElementVNode("p", _hoisted_9, _toDisplayString(inner.value) + " 秒后返回首页", 1)
                  ], 64))
                : (__props.status === 5)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createElementVNode("p", _hoisted_10, _toDisplayString(__props.toastString || '策略失效'), 1),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(inner.value) + " 秒后返回首页", 1)
                    ], 64))
                  : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})